import classNames from "classnames";
import React, { FC } from "react";

import { TStyleSize } from "@/eworkitComponents";
import { TColorVariant } from "@/style/colorVariants";

import "./_loading-spinner.scss";

interface ILoadingSpinnerProps {
  size?: TStyleSize;
  variant?: TColorVariant | "list";
}

export const LoadingSpinner: FC<ILoadingSpinnerProps> = ({ size = "xs", variant = "background-card" }) => {
  const rootClass = classNames(
    "loading-spinner",
    "el-loader",
    `el-loader--size-${size}`,
    `el-loader--variant-${variant}`,
  );

  return (
    <span className={rootClass}>
      <span className="el-loader__spinner" />
    </span>
  );
};
